var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fill: "#ed6c02",
    d: "m16.954,48c-4.4,0 -6.2,-3.118 -4,-6.928l15.046,-26.06c2.2,-3.811 5.8,-3.811 8,0l15.046,26.06c2.2,3.811 0.4,6.928 -4,6.928l-30.092,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    fill: "#ffffff",
    d: "m34,32c0,1.105 -0.895,2 -2,2l0,0c-1.105,0 -2,-0.895 -2,-2l0,-8c0,-1.105 0.895,-2 2,-2l0,0c1.105,0 2,0.895 2,2l0,8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_10",
    fill: "#ffffff",
    d: "m34,40c0,1.105 -0.895,2 -2,2l0,0c-1.105,0 -2,-0.895 -2,-2l0,0c0,-1.105 0.895,-2 2,-2l0,0c1.105,0 2,0.895 2,2l0,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.adf82277616e45bb54953eae70df53e3.svg";
export { ForwardRef as ReactComponent };